import { connect } from 'react-redux'
import Remote from "./Remote";

const mapStateToProps = (state, ownProps) => {
  return {
    mode: state.exam.mode
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {

  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Remote);
